<div class="user-search-wrapper" [class.user-search-wrapper-hide-mat-tab-header]="attachAbleUser.length == 1" [class.is-multiple]="multiple">
  <mat-tab-group (selectedIndexChange)="getActiveTab($event)">
    @if (checkAttachAbleUser(TYPE_USER)) {
      <mat-tab [label]="tabLabel(TYPE_USER)">
        <div class="search-ui">
          <div class="search-ui-container">
            <div class="search-ui-inner-container">
              <div class="search-ui-items w-100">
                <input type="text" class="search-ui-item w-100" placeholder="Press enter to search" style="width:100%  !important" [value]="searchTerm[TYPE_USER]" (change)="onSearchInput(TYPE_USER, $event)">
              </div>
            </div>
          </div>
        </div>
        <div class="tabs-ui">
          <div class="tabs-ui-contents">
            <div class="tabs-ui-content tabs-ui-content-active" (scroll)="onListScroll(TYPE_USER, $event)">
              <div class="ui-items">
                @if (isLoading[TYPE_USER]) {
                  @for (row of skeletonRows; track $index) {
                    <div class="ui-item-skeleton">
                      <div class="skeleton-avatar"></div>
                      <div class="skeleton-lines">
                        <div class="skeleton-line short"></div>
                        <div class="skeleton-line medium"></div>
                      </div>
                    </div>
                  }
                } @else if (usersList.length === 0) {
                  <div class="ui-empty-state">No users found</div>
                } @else {
                  @for (user of usersList; track user.id) {
                    <div class="ui-item-box" [class.is-selected]="multiple && isSelected(TYPE_USER, user)" [class.is-existing]="multiple && isExisting(TYPE_USER, user)" (click)="onItemClick(TYPE_USER, user)">
                      <div class="ui-selector-item">
                        <app-user-hover-card [user]="getHoverCardUser(TYPE_USER, user)" avatarSize="28px" class="ui-item-avatar-wrapper"></app-user-hover-card>
                        <div class="ui-item-titles">
                          <div class="item-title-box">
                            <div class="item-title">{{ getDisplayName(TYPE_USER, user) }}</div>
                          </div>
                          @if (user.email) {
                            <div class="item-subtitle">{{ user.email }}</div>
                          }
                        </div>
                        @if (multiple && isSelected(TYPE_USER, user)) {
                          <mat-icon class="ui-item-check" [matTooltip]="isExisting(TYPE_USER, user) ? 'Already added' : ''">check_circle</mat-icon>
                        }
                      </div>
                    </div>
                  }
                  @if (isLoadingMore[TYPE_USER]) {
                    @for (row of loadMoreSkeletonRows; track $index) {
                      <div class="ui-item-skeleton">
                        <div class="skeleton-avatar"></div>
                        <div class="skeleton-lines">
                          <div class="skeleton-line short"></div>
                          <div class="skeleton-line medium"></div>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    }

    @if (checkAttachAbleUser(TYPE_VENDORS)) {
      <mat-tab [label]="tabLabel(TYPE_VENDORS)">
        <div class="search-ui">
          <div class="search-ui-container">
            <div class="search-ui-inner-container">
              <div class="search-ui-items w-100">
                <input type="text" class="search-ui-item w-100" placeholder="Press enter to search" style="width:100%  !important" [value]="searchTerm[TYPE_VENDORS]" (change)="onSearchInput(TYPE_VENDORS, $event)">
              </div>
            </div>
          </div>
        </div>
        <div class="tabs-ui">
          <div class="tabs-ui-contents">
            <div class="tabs-ui-content tabs-ui-content-active" (scroll)="onListScroll(TYPE_VENDORS, $event)">
              <div class="ui-items">
                @if (isLoading[TYPE_VENDORS]) {
                  @for (row of skeletonRows; track $index) {
                    <div class="ui-item-skeleton">
                      <div class="skeleton-avatar"></div>
                      <div class="skeleton-lines">
                        <div class="skeleton-line short"></div>
                        <div class="skeleton-line medium"></div>
                      </div>
                    </div>
                  }
                } @else if (vendorsList.length === 0) {
                  <div class="ui-empty-state">No vendors found</div>
                } @else {
                  @for (user of vendorsList; track user.id) {
                    <div class="ui-item-box" [class.is-selected]="multiple && isSelected(TYPE_VENDORS, user)" [class.is-existing]="multiple && isExisting(TYPE_VENDORS, user)" (click)="onItemClick(TYPE_VENDORS, user)">
                      <div class="ui-selector-item">
                        <app-user-hover-card [user]="getHoverCardUser(TYPE_VENDORS, user)" avatarSize="28px" class="ui-item-avatar-wrapper"></app-user-hover-card>
                        <div class="ui-item-titles">
                          <div class="item-title-box">
                            <div class="item-title">{{ getDisplayName(TYPE_VENDORS, user) }}</div>
                          </div>
                          @if (user.email) {
                            <div class="item-subtitle">{{ user.email }}</div>
                          }
                        </div>
                        @if (multiple && isSelected(TYPE_VENDORS, user)) {
                          <mat-icon class="ui-item-check" [matTooltip]="isExisting(TYPE_VENDORS, user) ? 'Already added' : ''">check_circle</mat-icon>
                        }
                      </div>
                    </div>
                  }
                  @if (isLoadingMore[TYPE_VENDORS]) {
                    @for (row of loadMoreSkeletonRows; track $index) {
                      <div class="ui-item-skeleton">
                        <div class="skeleton-avatar"></div>
                        <div class="skeleton-lines">
                          <div class="skeleton-line short"></div>
                          <div class="skeleton-line medium"></div>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    }

    @if (checkAttachAbleUser(TYPE_CUSTOMERS)) {
      <mat-tab [label]="tabLabel(TYPE_CUSTOMERS)">
        <div class="search-ui">
          <div class="search-ui-container">
            <div class="search-ui-inner-container">
              <div class="search-ui-items w-100">
                <input type="text" class="search-ui-item w-100" placeholder="Press enter to search" style="width:100%  !important" [value]="searchTerm[TYPE_CUSTOMERS]" (change)="onSearchInput(TYPE_CUSTOMERS, $event)">
              </div>
            </div>
          </div>
        </div>
        <div class="tabs-ui">
          <div class="tabs-ui-contents">
            <div class="tabs-ui-content tabs-ui-content-active">
              <div class="ui-items">
                @if (isLoading[TYPE_CUSTOMERS]) {
                  @for (row of skeletonRows; track $index) {
                    <div class="ui-item-skeleton">
                      <div class="skeleton-avatar"></div>
                      <div class="skeleton-lines">
                        <div class="skeleton-line short"></div>
                        <div class="skeleton-line medium"></div>
                      </div>
                    </div>
                  }
                } @else if (customersList.length === 0) {
                  <div class="ui-empty-state">No customers found</div>
                } @else {
                  @for (user of customersList; track user.id) {
                    <div class="ui-item-box" [class.is-selected]="multiple && isSelected(TYPE_CUSTOMERS, user)" [class.is-existing]="multiple && isExisting(TYPE_CUSTOMERS, user)" (click)="onItemClick(TYPE_CUSTOMERS, user)">
                      <div class="ui-selector-item">
                        <app-user-hover-card [user]="getHoverCardUser(TYPE_CUSTOMERS, user)" avatarSize="28px" class="ui-item-avatar-wrapper"></app-user-hover-card>
                        <div class="ui-item-titles">
                          <div class="item-title-box">
                            <div class="item-title">{{ getDisplayName(TYPE_CUSTOMERS, user) }}</div>
                          </div>
                          @if (user.email) {
                            <div class="item-subtitle">{{ user.email }}</div>
                          }
                        </div>
                        @if (multiple && isSelected(TYPE_CUSTOMERS, user)) {
                          <mat-icon class="ui-item-check" [matTooltip]="isExisting(TYPE_CUSTOMERS, user) ? 'Already added' : ''">check_circle</mat-icon>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    }

    @if (checkAttachAbleUser(TYPE_SUBCONTRACTORS)) {
      <mat-tab [label]="tabLabel(TYPE_SUBCONTRACTORS)">
        <div class="search-ui">
          <div class="search-ui-container">
            <div class="search-ui-inner-container">
              <div class="search-ui-items w-100">
                <input type="text" class="search-ui-item w-100" placeholder="Press enter to search" style="width:100%  !important" [value]="searchTerm[TYPE_SUBCONTRACTORS]" (change)="onSearchInput(TYPE_SUBCONTRACTORS, $event)">
              </div>
            </div>
          </div>
        </div>
        <div class="tabs-ui">
          <div class="tabs-ui-contents">
            <div class="tabs-ui-content tabs-ui-content-active">
              <div class="ui-items">
                @if (isLoading[TYPE_SUBCONTRACTORS]) {
                  @for (row of skeletonRows; track $index) {
                    <div class="ui-item-skeleton">
                      <div class="skeleton-avatar"></div>
                      <div class="skeleton-lines">
                        <div class="skeleton-line short"></div>
                        <div class="skeleton-line medium"></div>
                      </div>
                    </div>
                  }
                } @else if (subcontractorsList.length === 0) {
                  <div class="ui-empty-state">No subcontractors found</div>
                } @else {
                  @for (user of subcontractorsList; track user.id) {
                    <div class="ui-item-box" [class.is-selected]="multiple && isSelected(TYPE_SUBCONTRACTORS, user)" [class.is-existing]="multiple && isExisting(TYPE_SUBCONTRACTORS, user)" (click)="onItemClick(TYPE_SUBCONTRACTORS, user)">
                      <div class="ui-selector-item">
                        <app-user-hover-card [user]="getHoverCardUser(TYPE_SUBCONTRACTORS, user)" avatarSize="28px" class="ui-item-avatar-wrapper"></app-user-hover-card>
                        <div class="ui-item-titles">
                          <div class="item-title-box">
                            <div class="item-title">{{ getDisplayName(TYPE_SUBCONTRACTORS, user) }}</div>
                          </div>
                          @if (user.email) {
                            <div class="item-subtitle">{{ user.email }}</div>
                          }
                        </div>
                        @if (multiple && isSelected(TYPE_SUBCONTRACTORS, user)) {
                          <mat-icon class="ui-item-check" [matTooltip]="isExisting(TYPE_SUBCONTRACTORS, user) ? 'Already added' : ''">check_circle</mat-icon>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    }
  </mat-tab-group>

  @if (multiple) {
    <div class="picker-footer">
      <span class="picker-footer-count">{{ selected.size }} selected</span>
      <div class="picker-footer-actions">
        <button type="button" class="picker-btn-cancel" (click)="close()">Cancel</button>
        <button type="button" class="picker-btn-add" [disabled]="!selected.size" (click)="confirmSelection()">Add</button>
      </div>
    </div>
  }
</div>
